import { render, staticRenderFns } from "./GlobalVariable.vue?vue&type=template&id=1d0bd009"
import script from "./GlobalVariable.vue?vue&type=script&lang=js"
export * from "./GlobalVariable.vue?vue&type=script&lang=js"
import style0 from "./GlobalVariable.vue?vue&type=style&index=0&id=1d0bd009&prod&lang=scss"
import style1 from "./GlobalVariable.vue?vue&type=style&index=1&id=1d0bd009&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports